function getSrcAttribute(scriptElementString:string) {
    const srcRegex = /<script.+src=(?:"|')(.+?)(?:"|').*><\/script>/i;
    const match = scriptElementString.match(srcRegex);
    if (match && match[1]) {
      return match[1];
    }
    return null;
  }

  export default getSrcAttribute